import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

// components

import AdminNavbar from "components/Navbars/AdminNavbar.js";
import TentorSidebar from "components/Sidebar/TentorSidebar";
import HeaderStats from "components/Headers/HeaderStats.js";
import FooterAdmin from "components/Footers/FooterAdmin.js";

//page presensi
import Presensi from "views/tentor/presensi/Presensi";
import CreatePresensi from "views/tentor/presensi/PresensiCreate";
import ViewPresensi from "views/tentor/presensi/PresensiView";
import UpdatePresensi from "views/tentor/presensi/PresensiUpdate";
import DeletePresensi from "views/tentor/presensi/PresensiDelete";


export default function Admin() {
  return (
    <>
      <TentorSidebar />
      <div className="relative md:ml-64 bg-blueGray-100">
        {/* <AdminNavbar /> */}
        {/* Header */}
        {/* <HeaderStats /> */}
        <div className="px-4 md:px-10 mx-auto w-full -m-24">
          <Switch>
            <Route path="/tentor/presensi" exact component={Presensi} />
            <Route path="/tentor/presensi/create" exact component={CreatePresensi} />
            <Route path="/tentor/presensi/view/:presensiId" exact component={ViewPresensi} />
            <Route path="/tentor/presensi/update/:presensiId" exact component={UpdatePresensi} />
            <Redirect from="/tentor" to="/tentor/presensi" />
          </Switch>
          <FooterAdmin />
        </div>
      </div>
    </>
  );
}
